import React, { useState, useEffect, useCallback, useRef } from 'react';
import { format } from 'date-fns';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';
import { cn, safeParseDate } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';
import FilterTagCom from '../FilterTag';

// New modern widget components
import BarListChart from '../BarListChart';
import ColumnPieChart from '../ColumnPieChart';
import ListChartWidget from '../ListChartWidget';
import MultiStackBarChart from '../MultiStackBarChart';


function BrokerDashboard({ 
    dashboardName: propDashboardName, 
    startDate: propStartDate, 
    endDate: propEndDate, 
    handeChangefilter,
    handleAllDirectOverride_user,
    Wholesaler,
    DisEmail,
    DisName,
    dist_usertype: propDistUserType,
    filterUpdateTrigger
}) {
    // Get stored dates and user info
    const getInitialState = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;

        let filterdatalocal = localStorage.getItem('Advance_Filter');
        if (filterdatalocal == null || filterdatalocal === '' || filterdatalocal === undefined || filterdatalocal === "null") {
            filterdatalocal = '';
        }

        let roletype = '', rolename = '', whId = 0, distributorUserId = 0;
        try {
            const userdata = JSON.parse(localStorage.getItem('user'));
            try { distributorUserId = userdata.distributor_UserId; } catch (e) {}
            if (userdata.userrole === "Distributor" && userdata.wholesaler === "Avenel_lll") {
                roletype = "avdistributor";
                rolename = userdata.email;
                whId = userdata.wholesaler_Id;
            } else if (userdata.userrole === "Distributor" && userdata.wholesaler !== "Avenel_lll") {
                roletype = "distributor";
                rolename = userdata.paramsname;
                whId = userdata.wholesaler_Id;
            } else {
                roletype = userdata.userrole;
                rolename = userdata.paramsname;
                whId = userdata.wholesaler_Id;
            }
        } catch (e) {}

        return {
            startdate, enddate, filterdatalocal, roletype, rolename, whId, distributorUserId,
            userdata: JSON.parse(localStorage.getItem('user') || '{}')
        };
    };

    const initial = getInitialState();

    const [state, setState] = useState({
        userdata: initial.userdata,
        scrollArray: {},
        graphData: [],
        dashboardName: propDashboardName,
        wholesalerName: Wholesaler,
        DistributorEmail: DisEmail,
        endDate: format(initial.enddate, "yyyyMMdd"),
        startDate: format(initial.startdate, "yyyyMMdd"),
        FilterTagList: initial.filterdatalocal,
        roletype: initial.roletype,
        rolename: initial.rolename,
        wh_Id: initial.whId,
        distributor_UserId: initial.distributorUserId,
        dist_usertype: propDistUserType,
        isEnrollEndpointEnabled: false,
        isBrokerDataCount: 0
    });

    const prevDistUserTypeRef = useRef(propDistUserType);

    // Get colors based on domain
    const getColors = useCallback(() => {
        const host = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        const isRxHacker = host === "rxhacker.com" || host === "localhost:5464" || 
                          window.location.host.toLowerCase() === "tempfilter.23byt.es" || 
                          window.location.host.toLowerCase() === "reporting.nulifespanrx.com";
        
        if (isRxHacker) {
            return {
                primary: ColorJson.ApplicationColor.Rxhacker_primary_color,
                secondary: ColorJson.ApplicationColor.Rxhacker_secondary_color,
                extra: ColorJson.ApplicationColor.Rxhacker_extra_color
            };
        }
        return {
            primary: ColorJson.ApplicationColor.Glic_primary_color,
            secondary: ColorJson.ApplicationColor.Glic_secondary_color,
            extra: ColorJson.ApplicationColor.Glic_extra_color
        };
    }, []);

    // Handle API response
    const handleResponse = useCallback((response) => {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            } catch (e) {
                return [];
            }
        });
    }, []);

    // Get broker enrollment API status
    const getBrokerEnrollmentAPIStatus = useCallback((whId, distributorUserId) => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Wh_Id: whId, distributor_UserId: distributorUserId })
            };
            return fetch(`/api/Broker/getBroker_Enrollment_API_Status`, requestOptions)
                .then(handleResponse)
                .then(apidata => {
                    if (apidata && apidata.length > 0) {
                        setState(prev => ({
                            ...prev,
                            isEnrollEndpointEnabled: apidata[0].colValue,
                            isBrokerDataCount: apidata[0].row_Count
                        }));
                    }
                });
        } catch (e) {
            return Promise.resolve();
        }
    }, [handleResponse]);

    // Build graph data
    const buildGraphData = useCallback(() => {
        let wname = propDashboardName;
        const startDate = format(safeParseDate(propStartDate), "yyyyMMdd");
        const endDate = format(safeParseDate(propEndDate), "yyyyMMdd");
        const AllDirectOverride = propDistUserType;

        if (wname == null || wname === '') {
            wname = DisName;
        }

        // Set API URLs based on filter
        let APIBaseURL = "", APIBaseURL_New = "", APIBaseURL_New_Drug = "", 
            APIBaseURL_Enrollment = "", APIBaseURL_GnWisePaidClaims = "",
            APIBaseURL_EnrollmentGroup = "", APIBaseURL_ClientAccess = "", APIBaseURL_ClientAccessGroup = "";

        if (AllDirectOverride === 'All') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup_all';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup_all';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup_all';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup_all';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans_all';
            APIBaseURL = '/api/Broker/total_transactions_new_all';
            APIBaseURL_New = '/api/Broker/patient_savings_new_all';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new_all';
        } else if (AllDirectOverride === 'Direct') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans';
            APIBaseURL = '/api/Broker/total_transactions_new';
            APIBaseURL_New = '/api/Broker/patient_savings_new';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new';
        } else if (AllDirectOverride === 'Override') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup_override';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup_override';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup_override';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup_override';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans_override';
            APIBaseURL = '/api/Broker/total_transactions_new_override';
            APIBaseURL_New = '/api/Broker/patient_savings_new_override';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new_override';
        } else {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans';
            APIBaseURL = '/api/Broker/total_transactions_new';
            APIBaseURL_New = '/api/Broker/patient_savings_new';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new';
        }

        let AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
        } catch (e) {}

        const filterTagList = (AdFilterJson != null && AdFilterJson !== '' && AdFilterJson !== undefined && AdFilterJson !== "null")
            ? JSON.stringify(AdFilterJson)
            : '';

        const { primary: primaryColor, secondary: secondaryColor, extra: extraColor } = getColors();
        const filterTime = localStorage.getItem('Filter_Last_Update_Time');
        const hdType = localStorage.getItem('Updated_HD_Type');

        // Build request JSONs
        const buildRequestJson = (chartType, rcount = 0, extra = {}) => {
            return JSON.stringify({
                wname: String(state.userdata?.distributor_UserId || ''),
                whname: String(state.userdata?.wholesaler_Id || ''),
                start_date: startDate,
                end_date: endDate,
                rcount,
                chart_type: chartType,
                filtertime: filterTime,
                rxsClaimType: hdType,
                ...extra
            });
        };

        const PostData_PatientSaving_True = buildRequestJson("columnList", 30, { ispatientsaving: "true", pharmacynumber: "all" });
        const Drug_Transaction_PostData_RequestJson = buildRequestJson("pielist", 20);
        const TotalTransaction_PostData_RequestJson = buildRequestJson("columnList", 0, { ispatientsaving: "true", pharmacynumber: "all" });
        const Analytics_Widget1_RequestJson = buildRequestJson("columnList", 0, { ispatientsaving: "true", pharmacynumber: "all" });
        const Analytics_Widget2_RequestJson = buildRequestJson("columnList", 0, { ispatientsaving: "true", pharmacynumber: "all" });
        const MultiAxis_DeviceSignup = buildRequestJson("column_multiaxislist", 0, { ispatientsaving: "true", pharmacynumber: "all", wholesaler_id: state.userdata?.wholesaler_Id, widget_link: "" });
        const Widget4 = buildRequestJson("columnList", 0, { ispatientsaving: "true", pharmacynumber: "all", wholesaler_id: state.userdata?.wholesaler_Id, widget_link: "" });

        // Build widgets array
        const baseWidgets = [
            {
                url: state.isEnrollEndpointEnabled && state.isBrokerDataCount > 0 ? '/api/Broker/date_wise_signup' : APIBaseURL_Enrollment,
                type: "Bar_List", title: "Total Enrollment Center Signups", Subtitle: "Total number of user signups",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Date", YlabelString: "Number of Signups",
                interval: 'day', id: "Alalytic_widget_Broker1", BorderRadius: 0, RequestJson: Analytics_Widget1_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: state.isEnrollEndpointEnabled && state.isBrokerDataCount > 0 ? '/api/Broker/gn_wise_signup' : APIBaseURL_EnrollmentGroup,
                type: "Bar_List", title: "Enrollment Center Signups by Group Number", Subtitle: "Total number of signups for each Group Number",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Group Number", YlabelString: "Number of Signups",
                id: "Alalytic_widget_Broker2", BorderRadius: 0, RequestJson: Analytics_Widget2_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: state.isEnrollEndpointEnabled && state.isBrokerDataCount > 0 ? '/api/Broker/devicedatesignup' : APIBaseURL_ClientAccess,
                type: "MultiBar_List", title: "Client Access Link Signups", Subtitle: "Number of signups through Client Access Links",
                ColorCode: primaryColor, DataType: "NA", XlabelString: "Date", YlabelString: "Number of Signups",
                id: "Alalytic_widget3", RequestJson: MultiAxis_DeviceSignup, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: state.isEnrollEndpointEnabled && state.isBrokerDataCount > 0 ? '/api/Broker/devicegnsignup' : APIBaseURL_ClientAccessGroup,
                type: "Bar_List", title: "Client Access Link Signups by Group Number", Subtitle: "Number of signups through Client Access Links for each group number",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Group Number", YlabelString: "Number of Signups",
                id: "Alalytic_widget4", RequestJson: Widget4, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL, type: "Bar_List", title: "Paid Transactions", Subtitle: "Total number of paid transactions for each day",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Date", YlabelString: "# of Transactions",
                interval: 'day', id: "DTotalTransaction", BorderRadius: 0, RequestJson: TotalTransaction_PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL_GnWisePaidClaims, type: "Bar_List", title: "Paid Transactions by Group Number", Subtitle: "Total number of paid transactions for each group number",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Group Number", YlabelString: "# of Transactions",
                id: "GroupPaidTransaction", BorderRadius: 0, RequestJson: Analytics_Widget2_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL_New, type: "Bar_List", title: "Total Patient Savings ($)", Subtitle: "Total savings for all patients in $",
                ColorCode: secondaryColor, XlabelString: "Date", YlabelString: "Average Saving",
                id: "DMetric3A", Broker: true, BorderRadius: 0, RequestJson: PostData_PatientSaving_True, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL_New_Drug, type: "Column_Pie", title: "Top 20 Compensable Drugs", Subtitle: "Number of transactions for each drug",
                ColorCode: extraColor, DataType: "DrugName", id: "WDrugTransaction", RequestJson: Drug_Transaction_PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            }
        ];

        // Add API signup widgets if enabled
        if (state.isEnrollEndpointEnabled && state.isBrokerDataCount > 0) {
            baseWidgets.splice(4, 0, {
                url: '/api/Broker/date_wise_signup_api', type: "Bar_List", title: "API Signups", Subtitle: "Number of signups through API",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Date", YlabelString: "Number of Signups",
                interval: 'day', id: "Alalytic_widget5", RequestJson: Analytics_Widget1_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            });
            baseWidgets.splice(5, 0, {
                url: '/api/Broker/gn_wise_signup_api', type: "Bar_List", title: "API Signups by Group Number", Subtitle: "Number of signups through API for each group number",
                ColorCode: secondaryColor, DataType: "NA", XlabelString: "Group Number", YlabelString: "Number of Signups",
                id: "Alalytic_widget6", RequestJson: Analytics_Widget2_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            });
        }

        return { graphData: baseWidgets, filterTagList, startDate, endDate, dashboardName: wname };
    }, [propDashboardName, propStartDate, propEndDate, propDistUserType, DisName, state.userdata, state.isEnrollEndpointEnabled, state.isBrokerDataCount, getColors]);

    // Change data handler
    const changeData = useCallback(() => {
        const result = buildGraphData();
        setState(prev => ({
            ...prev,
            graphData: result.graphData,
            FilterTagList: result.filterTagList,
            startDate: result.startDate,
            endDate: result.endDate,
            dashboardName: result.dashboardName
        }));
    }, [buildGraphData]);

    // Handle filter change
    const handlechangea = useCallback((e) => {
        
        if (e && e.heading && e.value) {
            
            // Validate heading is not undefined or invalid
            
            if (e.heading === 'undefined' || !e.heading) {
                return;
            
            }
            
            try {
                let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
                
                if (Created_Advance_Filter[e.heading]) {
                    if (!Created_Advance_Filter[e.heading].includes(e.value)) {
                        Created_Advance_Filter[e.heading].push(e.value);
                    }
                } else {
                    Created_Advance_Filter[e.heading] = [e.value];
                }
                
                localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                
            } catch (error) {
            }
        }
        
        if (handeChangefilter) handeChangefilter(e);
    }, [handeChangefilter]);

    // Initialize on mount
    useEffect(() => {
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
        getBrokerEnrollmentAPIStatus(state.userdata?.wholesaler_Id, state.userdata?.distributor_UserId)
            .then(() => changeData());
    }, []);

    // Handle dist_usertype changes
    useEffect(() => {
        if (prevDistUserTypeRef.current !== propDistUserType) {
            prevDistUserTypeRef.current = propDistUserType;
            setState(prev => ({ ...prev, dist_usertype: propDistUserType }));
            localStorage.setItem('dist_usertype', propDistUserType);
            changeData();
        }
    }, [propDistUserType, changeData]);

    // Check for filter/date changes
    useEffect(() => {
        if (!propStartDate || !propEndDate) return;
        const startDate = format(safeParseDate(propStartDate), "yyyyMMdd");
        const endDate = format(safeParseDate(propEndDate), "yyyyMMdd");

        let IsCall = false;
        try {
            const prevFilter = localStorage.getItem('Prev_Filter_Status')?.toLowerCase();
            const updatedFilter = localStorage.getItem('Updated_Filter_Status')?.toLowerCase();
            if (prevFilter !== updatedFilter || localStorage.getItem('Prev_AdFilter_Status') !== localStorage.getItem('Updated_AdFilter_Status') || localStorage.getItem('Prev_HD_Type') !== localStorage.getItem('Updated_HD_Type')) {
                IsCall = true;
            }
        } catch (e) {}

        if (endDate !== state.endDate || startDate !== state.startDate || IsCall) {
            if (IsCall) {
                localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
            }
            changeData();
        }
    }, [propStartDate, propEndDate, state.startDate, state.endDate, changeData, filterUpdateTrigger]);

    // Update when enrollment status changes
    useEffect(() => {
        changeData();
    }, [state.isEnrollEndpointEnabled, state.isBrokerDataCount]);

    // Check user permissions
    try {
        const usertype = userService.Get_User_Type();
        if (userService.Check_LoggedIn_Status() === 'Login') return <Redirect to="/login" />;
        if (usertype?.toLowerCase() === 'wholesaler') return <Redirect to='/pageNotFound' />;
        if (usertype?.toLowerCase() === 'admin') return <Redirect to='/pageNotFound' />;
        if (usertype?.toLowerCase() === 'subadmin') return <Redirect to='/pageNotFound' />;
    } catch (e) {}

    const isWidgetVisible = (item) => {
        const shouldHide = (
            (state.wholesalerName?.toLowerCase() === 'avenel_llll' && item.title === 'Total Commission Earned' && item.type === "MultiBar_List")
            || (state.wholesalerName?.toLowerCase() !== 'avenel_llll' && item.title === 'Total Commission Earned' && item.type === "Bar_List")
        );
        return !shouldHide;
    };

    const isFullWidth = (itemId) => {
        const fullWidthIds = [
            'DTotalTransaction',        // Paid Transactions (date series)
            'Alalytic_widget_Broker1',  // Total Enrollment Center Signups (date series)
            'Alalytic_widget3',         // Client Access Link Signups (MultiBar)
            'Alalytic_widget5',         // API Signups (date series, conditional)
        ];
        return fullWidthIds.includes(itemId);
    };

    const renderWidgetContent = (item, index) => {
        switch (item.type) {
            // Modern widget components
            case "Bar_List":
                return <BarListChart data={item} key={"barlistgraph" + index} _Index={index} handlechangea={handlechangea} />;
            case "Column_Pie":
                return <ColumnPieChart data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={handlechangea} />;
            case "List":
                return <ListChartWidget data={item} key={"listgraph" + index} _Index={index} handlechangea={handlechangea} />;
            case "MultiBar_List":
                return <MultiStackBarChart data={item} key={"barlistgraph1" + index} _Index={index} />;
            
            default:
                return null;
        }
    };

    return (
        <div id="dashboard-container" className="space-y-6">
            <FilterTagCom dist_id={state.distributor_UserId} Rolename={state.rolename} wh_Id={state.wh_Id} Roletype={state.roletype} df={state.startDate} dt={state.endDate} handlechangea={handlechangea} FilterTags={state.FilterTagList} />
            <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                {state.graphData.length === 0 ? (
                    Array.from({ length: 8 }).map((_, i) => (
                        <div key={"skeleton-" + i} className="min-h-[420px]">
                            <Skeleton className="h-full w-full rounded-xl" />
                        </div>
                    ))
                ) : (
                    state.graphData.map((item, index) => {
                        if (!isWidgetVisible(item)) return null;
                        return (
                            <div 
                                key={"graph-widget" + index} 
                                id={item.id + index} 
                                className={cn(
                                    item.type !== "Claim" && item.type !== "Claim_New" && "min-h-[420px]",
                                    isFullWidth(item.id) && "2xl:col-span-2"
                                )}
                            >
                                {renderWidgetContent(item, index)}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default BrokerDashboard;
